import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MOCKUP_URL, heroChecks } from '../data/content';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-900 text-white" data-id="element-183" data-mp="9kjv2k5raw1k">
      <div className="bg-gold-400 px-4 py-2.5 text-center text-xs font-bold uppercase tracking-wider text-navy-900 sm:text-sm" data-id="element-184" data-mp="9ih0dmtnseqi">
        The Practical Clinical Decision System for Cosmetic & Restorative Dentists
      </div>

      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 pb-16 pt-10 md:px-8 lg:grid-cols-[1.05fr_1fr] lg:gap-14 lg:pb-24 lg:pt-16" data-id="element-185" data-mp="x9ur5oc5w29d">
        <div className="text-center lg:text-left" data-id="element-186" data-mp="s9ggdyj6ee7n">
          <p className="font-serif text-lg font-bold text-gold-300 sm:text-xl" data-id="element-187" data-mp="ncq2nhuufupe">
            Dental Veneer Complications Blueprint™
          </p>
          <h1 className="mt-4 font-serif text-[2rem] font-extrabold leading-[1.12] sm:text-5xl lg:text-[3.4rem]" data-id="element-188" data-mp="3d2torapbqmf2">
            Turn a Complex Veneer Complication Into a{' '}
            <span className="text-gold-400" data-id="element-189" data-mp="3j9kc5f0exnhp">Documented 5-Step Assessment</span> & Corrective
            Planning Workflow
          </h1>
          <p className="mt-5 text-lg leading-relaxed text-navy-100 sm:text-xl" data-id="element-190" data-mp="3o5j41cky9nmv">
            Using one practical clinical decision map. Stop piecing together scattered clinical
            observations, uncertain restoration findings, and disconnected treatment
            considerations.
          </p>

          <img src={MOCKUP_URL} alt="Dental Veneer Complications Blueprint: 6 volumes, 5 bonuses and the Veneer Complication Decision Map" className="mx-auto mt-8 w-full max-w-lg lg:hidden" data-id="element-191" data-mp="30fy9dwffp1xr" />

          <p className="mt-8 text-base leading-relaxed text-navy-100 sm:text-lg" data-id="element-192" data-mp="2vievixmner6c">
            With the <strong className="text-white" data-id="element-193" data-mp="2hin9qapw46hs">Veneer Complication Decision Map™</strong>,
            organize your findings, identify the key decisions requiring professional judgment,
            and build a structured corrective planning record — from initial assessment through
            documented next steps.
          </p>

          <p className="mt-6 font-serif text-xl font-bold text-white sm:text-2xl" data-id="element-194" data-mp="na9xyj16r4ia">
            One case. Five structured decision stages.{' '}
            <span className="text-gold-300" data-id="element-195" data-mp="i9vqp37erylb">One organized clinical planning record.</span>
          </p>

          <div className="mt-8 rounded-2xl border border-gold-500/40 bg-navy-800 p-5 sm:p-6" data-id="element-196" data-mp="dbastafmpr01">
            <p className="text-sm font-semibold uppercase tracking-wide text-gold-300" data-id="element-197" data-mp="1ayjg9az6xa4o">
              Get the complete Veneer Complication Blueprint
            </p>
            <p className="mt-1 flex items-baseline justify-center gap-2 lg:justify-start" data-id="element-198" data-mp="11151dfsx0teh">
              <span className="font-serif text-5xl font-extrabold text-white" data-id="element-199" data-mp="x0cq6h0hgefk">$27</span>
              <span className="text-base font-semibold text-navy-100" data-id="element-200" data-mp="3lu0454qihb1b">USD</span>
            </p>
            <div className="mt-5 flex justify-center lg:justify-start" data-id="element-201" data-mp="3hr3q7rbx233p">
              <CTAButton id="hero-cta" size="xl" label="Build My Veneer Complication Decision Workflow" data-id="element-202" data-mp="1x9kugm9v74h7" />
            </div>
            <ul className="mt-5 grid grid-cols-1 gap-2.5 text-left sm:grid-cols-2" data-id="element-203" data-mp="218jzs7zid396">
              {heroChecks.map(c => <li key={c} className="flex items-center gap-2 text-[15px] font-medium" data-id="element-204" data-mp="2b197crrxtwz8">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-205" data-mp="2g02iwennzdwr" />
                  {c}
                </li>)}
            </ul>
            <p className="mt-4 text-sm text-navy-100/75" data-id="element-206" data-mp="2l0qap2jpvys1">
              Digital professional resource • One-time payment • No subscription
            </p>
          </div>

          <p className="mt-6 text-sm text-navy-100/80" data-id="element-207" data-mp="2tz1xsuldkefq">
            Designed for cosmetic dentists, restorative dentists, and dental professionals involved
            in veneer assessment and treatment planning.
          </p>
        </div>

        <div className="hidden lg:block" data-id="element-208" data-mp="4bdw1dmdg5nk">
          <img src={MOCKUP_URL} alt="Dental Veneer Complications Blueprint: 6 volumes, 5 bonuses and the Veneer Complication Decision Map" className="w-full" data-id="element-209" data-mp="4acin2hvv72o" />
        </div>
      </div>
    </header>;
}